import { VALUATIONS_OTHER_LABEL } from 'common/constants/valuations';
import { SELECT_MULTIPLE_ALIASES } from 'pages/Valuations/util/constants';
import { determineDatabaseOption } from 'pages/Valuations/util/percentileOptionsTools';
import { BenchmarkApproach } from 'pages/ValuationsAllocation/util';
import { GetSelectionFromTVTProps } from './types';
import { DEFAULT_PERCENTILE_A, DEFAULT_PERCENTILE_B } from '../../utilities/constants';

const getSelectionFromTVT = (props: GetSelectionFromTVTProps) => {
  const { cell, value, multipleOptions, specificApproach } = props;
  const { alias } = cell;
  const percentileSelections = {
    percentile_selection_a: specificApproach?.percentile_selection_a ?? DEFAULT_PERCENTILE_A,
    percentile_selection_b: specificApproach?.percentile_selection_b ?? DEFAULT_PERCENTILE_B,
  } as BenchmarkApproach;
  
  if (SELECT_MULTIPLE_ALIASES.includes(alias)) {
    // if there is only one option it means there isn't a benchmark approach to read multiples from and the only choice is "Other".
    // if the value is the last option, it means it is "Other" (always the last option regardless of the number of multiples available)
    if (multipleOptions.length === 1 || Number(value) === multipleOptions.length - 1) {
      return VALUATIONS_OTHER_LABEL;
    }
    return determineDatabaseOption({ value, options: multipleOptions, specificApproach: percentileSelections });
  }
  return '';
};

export default getSelectionFromTVT;
